<!-- Start Register Area -->
<div class="register-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="register-form">
                <div class="logo">
                    <div class="logo">
                        <a routerLink="/dashboard/analytics">
                            <img src="../../../../../assets/img/logo-servicios-gt-name.svg" alt="">
                        </a>
                    </div>
                </div>

                <h2>Registro</h2>
                <p> Ingresa tus datos para crear una cuenta en el sistema</p>
                <form [formGroup]="formRegister" (ngSubmit)="sendDataUser()">
                    <div class="form-group">
                        <select class="form-control" formControlName="pais" name="pais">
                            <option value="" class="" [ngValue]="null" selected="selected">Selecciona tu país</option>
                            <option label="Guatemala" [ngValue]="6">Guatemala</option>
                            <option label="El Salvador" [ngValue]="7">El Salvador</option>
                            <option label="Honduras" [ngValue]="8">Honduras</option>
                            <option label="Nicaragua" [ngValue]="9">Nicaragua</option>
                            <option label="Costa Rica" [ngValue]="10">Costa Rica</option>
                            <option label="México" [ngValue]="11">México</option>
                            <option label="Colombia" [ngValue]="12">Colombia</option>
                            <option label="Venezuela" [ngValue]="13">Venezuela</option>
                            <option label="Ecuador" [ngValue]="14">Ecuador</option>
                            <option label="Perú" [ngValue]="15">Perú</option>
                            <option label="Argentina" [ngValue]="16">Argentina</option>
                            <option label="Chile" [ngValue]="17">Chile</option>
                            <option label="Panamá" [ngValue]="18">Panamá</option>
                            <option label="España" [ngValue]="19">España</option>
                        </select>
                        <span class="label-title"><i class='bx bx-world'></i></span>
                    </div>
                    <div class="form-group">
                        <input type="text" class="form-control" formControlName="mail" id="mail" name="mail"
                            placeholder="Correo" data-bs-toggle="tooltip" data-bs-placement="right" data-bs-html="true"
                            data-bs-custom-class="custom-tooltip"
                            data-bs-title="<em>Ingresa un correo electronico con formato</em><br><b>usuario@servidordecorreo.com</b>">
                        <span class="label-title"><i class='bx bx-envelope'></i></span>
                    </div>
                    <div class="form-group">
                        <input type="password" class="form-control" formControlName="pass" (keyup)="checkPassword($event)"
                            name="pass" placeholder="Contraseña">
                        <span class="label-title"><i class='bx bx-lock'></i></span>
                    </div>
                    <p class="mb-3 mt-0" style="font-size: 1em;" class="container-password-requirements"
                        *ngIf="startPassword">
                        Tu contraseña debe de contener
                        <br>
                        <span [ngClass]="length8 ? 'text-success' : 'text-error'" class="password-requirement">al menos
                            8 carácteres
                            <i [ngClass]="length8 ? 'bxs-check-circle' : 'bxs-error'" class="bx" data-toggle="tooltip"
                                data-placement="top"
                                [attr.data-bs-original-title]="length8 ? 'Correcto' : 'A tu contraseña le faltan carácteres'"></i></span>,
                        <span [ngClass]="mayusExist ? 'text-success' : 'text-error'"
                            class="password-requirement">mayúsculas
                            <i [ngClass]="mayusExist ? 'bxs-check-circle' : 'bxs-error'" class="bx"
                                data-toggle="tooltip" data-placement="top"
                                [attr.data-bs-original-title]="mayusExist ? 'Correcto' : 'A tu contraseña le faltan mayúsculas'"></i></span>,
                        <span [ngClass]="minusExist ? 'text-success' : 'text-error'"
                            class="password-requirement">minúsculas
                            <i [ngClass]="minusExist ? 'bxs-check-circle' : 'bxs-error'" class="bx"
                                data-toggle="tooltip" data-placement="top"
                                [attr.data-bs-original-title]="minusExist ? 'Correcto' : 'A tu contraseña le faltan minúsculas'"></i></span>
                        y
                        <span [ngClass]="numbersExist ? 'text-success' : 'text-error'"
                            class="password-requirement">números
                            <i [ngClass]="numbersExist ? 'bxs-check-circle' : 'bxs-error'" class="bx"
                                data-bs-toggle="tooltip" data-bs-placement="right" data-bs-html="true"
                                data-bs-custom-class="custom-tooltip"
                                data-bs-title="<em>Ingresa una contraseña con al menos</em><br><b>al menos 8 caracteres, mayúsculas, minúsculas y números</b>"
                                [attr.data-bs-title]="numbersExist ? 'Correcto' : 'A tu contraseña le faltan números'"></i></span>
                    </p>
                    <p *ngIf="messageError" class="text-danger" style="font-weight: bolder;">
                        <i class="fa-solid fa-triangle-exclamation"></i>{{messageError}}
                    </p>
                    <button type="submit" [disabled]="sending" class="register-btn">
                        <app-loading-animation *ngIf="sending" [color]="'white'" [height]="'1.1rem'" style="display: inline-block;"></app-loading-animation>
                        Registrarme
                    </button>
                    <p class="mb-0">¿Ya tienes una cuenta? <a routerLink="/authentication/login">Ingresa</a></p>
                </form>
            </div>
        </div>
    </div>
</div>
<!-- End Register Area -->